import React from 'react';
import { ReactComponent as HomeIcon } from '../../../../assets/icons/Home.svg';
import { ReactComponent as HomeIconWhite } from '../../../../assets/icons/Home-w.svg';
import { ReactComponent as DexaIcon } from '../../../../assets/icons/dexa.svg';
import { ReactComponent as MacIcon } from '../../../../assets/icons/Display.svg';
import { ReactComponent as MacIconWhite } from '../../../../assets/icons/Display-w.svg';
import { ReactComponent as RadioBtnIconWhite } from '../../../../assets/icons/Radiobutton-active.svg';
import { ReactComponent as RadioBtnIcon } from '../../../../assets/icons/Radiobutton.svg';
import { ReactComponent as HistoryIcon } from '../../../../assets/icons/History.svg';
import { ReactComponent as HistoryIconWhite } from '../../../../assets/icons/History-w.svg';
import { ReactComponent as BuildingsIcon } from '../../../../assets/icons/Buildings.svg';
import { ReactComponent as BuildingsIconWhite } from '../../../../assets/icons/Buildings-w.svg';
import { LocationType } from '../../../../types/apiGeneratedTypes';

type Props = {
  onLocationBtnClick: (location: LocationType) => void;
  currentLocationOption: LocationType;
  membershipType?: string | null;
  isAppointmentView?: boolean;
};

const LocationButtons = ({
  onLocationBtnClick,
  currentLocationOption,
  membershipType,
  isAppointmentView = false,
}: Props) => {
  const isCoreMember = membershipType?.toLowerCase() === 'core';

  const handleClick = (location: LocationType) => {
    if (isAppointmentView) return;
    onLocationBtnClick(location);
  };

  const btnClass = (location: LocationType) =>
    `location-btn ${
      currentLocationOption === location ? 'active' : ''
    }${isAppointmentView ? ' location-btn--disabled' : ''}`;

  return (
    <>
      <div
        className={btnClass(LocationType.CLINIC)}
        onClick={() => handleClick(LocationType.CLINIC)}
      >
        <div className='icons'>
          {currentLocationOption === LocationType.CLINIC ? (
            <HomeIconWhite className='location-icon location-icon--home' />
          ) : (
            <HomeIcon className='location-icon location-icon--home' />
          )}
          {currentLocationOption === LocationType.CLINIC ? (
            <RadioBtnIconWhite className='radio-btn' />
          ) : (
            <RadioBtnIcon className='radio-btn' />
          )}
        </div>
        <span>Blood Clinic</span>
      </div>

      <div
        className={btnClass(LocationType.ONLINE)}
        onClick={() => handleClick(LocationType.ONLINE)}
      >
        <div className='icons'>
          {currentLocationOption === LocationType.ONLINE ? (
            <MacIconWhite className='location-icon' />
          ) : (
            <MacIcon className='location-icon' />
          )}
          {currentLocationOption === LocationType.ONLINE ? (
            <RadioBtnIconWhite className='radio-btn' />
          ) : (
            <RadioBtnIcon className='radio-btn' />
          )}
        </div>
        <span>Online</span>
      </div>

      <div
        className={btnClass(LocationType.HISTORICRESULTS)}
        onClick={() => handleClick(LocationType.HISTORICRESULTS)}
      >
        <div className='icons'>
          {currentLocationOption === LocationType.HISTORICRESULTS ? (
            <HistoryIconWhite className='location-icon' />
          ) : (
            <HistoryIcon className='location-icon' />
          )}
          {currentLocationOption === LocationType.HISTORICRESULTS ? (
            <RadioBtnIconWhite className='radio-btn' />
          ) : (
            <RadioBtnIcon className='radio-btn' />
          )}
        </div>
        <span>Historic Results</span>
      </div>

      <div
        className={btnClass(LocationType.MEMBER_HOME)}
        onClick={() => handleClick(LocationType.MEMBER_HOME)}
      >
        <div className='icons'>
          {currentLocationOption === LocationType.MEMBER_HOME ? (
            <HomeIconWhite className='location-icon location-icon--home' />
          ) : (
            <HomeIcon className='location-icon location-icon--home' />
          )}
          {currentLocationOption === LocationType.MEMBER_HOME ? (
            <RadioBtnIconWhite className='radio-btn' />
          ) : (
            <RadioBtnIcon className='radio-btn' />
          )}
        </div>
        <span>Blood Home Visit</span>
      </div>

      <div
        className={btnClass(LocationType.DEXA)}
        onClick={() => handleClick(LocationType.DEXA)}
      >
        <div className='icons'>
          <DexaIcon className='location-icon' />
          {currentLocationOption === LocationType.DEXA ? (
            <RadioBtnIconWhite className='radio-btn' />
          ) : (
            <RadioBtnIcon className='radio-btn' />
          )}
        </div>
        <span>DEXA</span>
      </div>

      {!isCoreMember && (
        <div
          className={btnClass(LocationType.SCAN)}
          onClick={() => handleClick(LocationType.SCAN)}
        >
          <div className='icons'>
            {currentLocationOption === LocationType.SCAN ? (
              <BuildingsIconWhite className='location-icon' />
            ) : (
              <BuildingsIcon className='location-icon' />
            )}
            {currentLocationOption === LocationType.SCAN ? (
              <RadioBtnIconWhite className='radio-btn' />
            ) : (
              <RadioBtnIcon className='radio-btn' />
            )}
          </div>
          <span>Scan</span>
        </div>
      )}
    </>
  );
};

export default LocationButtons;
